var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3055 18.6089C36.3055 8.65316 28.2848 0.583496 18.3888 0.583496C8.49286 0.583496 0.472168 8.65316 0.472168 18.6089C0.472168 27.6078 7.0225 35.0647 15.5891 36.4168V23.8202H11.0406V18.6077H15.5891V14.6373C15.5891 10.1199 18.2634 7.62355 22.3568 7.62355C24.3157 7.62355 26.3677 7.97591 26.3677 7.97591V12.4121H24.1066C21.8814 12.4121 21.1886 13.8024 21.1886 15.2286V18.6089H26.1575L25.3632 23.819H21.1886V36.4168C29.7552 35.0647 36.3055 27.6078 36.3055 18.6089Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6b39a9ba7fda2a7f0632149d1e5114c1.svg";
export { ForwardRef as ReactComponent };